import { useEffect, useRef, useState } from 'react';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import PropTypes from 'prop-types';

const TextReadMore = ({ text }) => {
  const divRef = useRef();
  const spanRef = useRef();
  const [doShowMoreButton, setDoShowMoreButton] = useState(false);
  const [doShowFullText, setDoShowFullText] = useState(false);
  useEffect(() => {
    setDoShowMoreButton(
      spanRef &&
        divRef &&
        spanRef.current &&
        divRef.current &&
        spanRef.current.offsetWidth > divRef.current.offsetWidth,
    );
  }, [spanRef, divRef]);

  const handleReadMore = () => {
    setDoShowFullText((v) => !v);
  };

  return (
    <div
      ref={divRef}
      className={`w-full relative ${doShowMoreButton ? 'pr-24' : ''} ${!doShowFullText ? 'truncate' : ''}`}
    >
      <span ref={spanRef}>{text}</span>
      {doShowMoreButton && (
        <button
          type="button"
          className="absolute right-0 underline text-theme focus:outline-none"
          onClick={handleReadMore}
        >
          Read {doShowFullText ? 'less' : 'more'}{' '}
          {doShowFullText ? (
            <ExpandLessOutlinedIcon className="-ml-1" />
          ) : (
            <ExpandMoreOutlinedIcon className="-ml-1" />
          )}
        </button>
      )}
    </div>
  );
};

TextReadMore.propTypes = {
  text: PropTypes.string.isRequired,
};

export default TextReadMore;
